var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CommonExpansionPanel',{scopedSlots:_vm._u([{key:"title-panel",fn:function(){return [_vm._v(" Historial de modificaciones ")]},proxy:true}])},[_c('v-expansion-panel-content',[_c('ViewLogCliente',{attrs:{"clienteInfo":_vm.clienteInfo,"canEdit":_vm.canEdit}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }